import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ReportService} from '../../../services/report.service';
import {MatDialog} from '@angular/material/dialog';
import {ErvoDialogComponent} from './ervo-dialog/ervo-dialog.component';
import {NotificationService} from '../../../services/notification.service';
import {ReportStatusDTO} from '../../../model/reportStatusDTO';
import {ReportTypeCode} from '../../../model/reportTypeCode';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
})
export class ReportListComponent implements OnInit {

  codeEnum = ReportTypeCode; // for template accessibility

  @Input() reports: ReportStatusDTO[] = [];
  @Input() clientId: number;
  @Input() immutable = false;

  reportMap = new Map<ReportTypeCode, ReportStatusDTO[]>([
    [ReportTypeCode.Bb,   []],
    [ReportTypeCode.Rv,   []],
    [ReportTypeCode.Vje,  []],
    [ReportTypeCode.Erv,  []],
    [ReportTypeCode.Ervo, []],
  ]);

  constructor(private router: Router,
              private route: ActivatedRoute,
              private notificationService: NotificationService,
              private reportService: ReportService,
              public dialog: MatDialog,
              public userService: UserService,
              private translate: TranslateService) {
    translate.use('nl');
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['clientId'])
        this.clientId = params['clientId'];
      this.init();
    });
  }

  private init() {
    if (!this.immutable) {
      this.reportService.getReportStatusList(this.clientId)
        .subscribe((reports) => this.getReports(reports));
    } else {
      this.getReports(this.reports);
    }
  }

  private getReports(reports: ReportStatusDTO[]) {
    for (const report of reports) {
      this.reportMap.get(report.code).push(report);
    }
    const comparator = (a, b) => a.year - b.year;
    for (const key of this.reportMap.keys()) {
      const array = this.reportMap.get(key);
      array.sort(comparator);
    }
  }

  createErv() {
    this.dialog.open(ErvoDialogComponent, { data: { clientId: this.clientId } } ).afterClosed().subscribe(() => {});
  }

  createBb() {
    const that = this;
    this.notificationService.confirm({header: 'Boedelbeschrijving aanmaken?', ok: 'Aanmaken'}).then(() => {
      this.reportService.create(this.clientId, ReportTypeCode.Bb)
        .subscribe(() => this.router.navigate(that.reportService.getReportUrl(this.clientId, ReportTypeCode.Bb, null)));
    });
  }
}
